import React, { useEffect } from 'react';
import { useFlightRangeHistory } from '../hooks/useFlightRangeHistory';
import FlightRangeHistoryTable from '../Components/FlightRange/FlightRangeHistoryTable';
import './FlightRangeHistory.scss';

/**
 * Main Flight Range History view component
 * Follows loose coupling principle - minimal external dependencies
 * Maintains low cyclomatic complexity with clear error handling
 */
const FlightRangeHistory: React.FC = () => {
  const { historyData, isLoading, error, fetchHistory } = useFlightRangeHistory();

  // Fetch history data on component mount
  useEffect(() => {
    fetchHistory();
  }, [fetchHistory]);

  // Error state rendering
  if (error) {
    return (
      <div className="history-view">
        <div 
          className="history-view__error" 
          role="alert"
          aria-live="assertive"
        >
          <div className="error-icon" aria-hidden="true">⚠️</div>
          <div className="error-content">
            <h3>Unable to Load History</h3>
            <p>{error}</p>
            <button 
              className="error-retry-button"
              onClick={fetchHistory}
              type="button"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="history-view">
      <div className="history-view__content">
        <FlightRangeHistoryTable 
          data={historyData} 
          isLoading={isLoading} 
        />
      </div>
    </div>
  );
};

export default FlightRangeHistory;